import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=31042312&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/menu.scss?vue&type=style&index=0&id=31042312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31042312",
  null
  
)

export default component.exports